/* eslint-disable no-unused-vars */

export enum NON_APARTMENT_CALCULATION_TYPE_NAME {
    GSF = 'GSF',
    RSF = 'RSF'
}

export enum APARTMENT_CALCULATION_TYPE_NAME {
    UNIT = 'unit',
    SF = 'sf'
}

export const IncomeCalculationTypeOptionsNonApartmentEstimate = [
    { value: NON_APARTMENT_CALCULATION_TYPE_NAME.GSF, label: NON_APARTMENT_CALCULATION_TYPE_NAME.GSF },
];

export const IncomeCalculationTypeOptionsNonApartmentTenants = [
    { value: NON_APARTMENT_CALCULATION_TYPE_NAME.GSF, label: NON_APARTMENT_CALCULATION_TYPE_NAME.GSF },
    { value: NON_APARTMENT_CALCULATION_TYPE_NAME.RSF, label: NON_APARTMENT_CALCULATION_TYPE_NAME.RSF },
];

export const IncomeCalculationTypeOptionsApartment = [
    { value: APARTMENT_CALCULATION_TYPE_NAME.UNIT, label: APARTMENT_CALCULATION_TYPE_NAME.UNIT },
    { value: APARTMENT_CALCULATION_TYPE_NAME.SF, label: APARTMENT_CALCULATION_TYPE_NAME.SF.toUpperCase() },
];
